import { Injectable } from '@angular/core';

import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { IResidentFeedbackEligibility, IResidentFeedbackInput } from '../../models';
import { feedbackEligibleQuery, saveFeedbackMutation } from '../../queries';

@Injectable()
export class ResidentFeedbackFacade {
  constructor(private apollo: Apollo) {}

  public saveFeedback(input: IResidentFeedbackInput): Observable<boolean> {
    return this.apollo
      .mutate<{ saveFeedback: boolean }>({
        mutation: saveFeedbackMutation,
        fetchPolicy: 'no-cache',
        variables: { input },
      })
      .pipe(
        map(response => response?.data?.saveFeedback ?? false),
        catchError((error: Error) => {
          console.error(error);
          throw new Error(error.message);
        })
      );
  }

  public getEligibility(): Observable<IResidentFeedbackEligibility> {
    return this.apollo
      .query<{ feedbackEligible: boolean }>({
        query: feedbackEligibleQuery,
        fetchPolicy: 'no-cache',
      })
      .pipe(
        // The endpoint returns a bare Boolean!; wrap it so the slice keeps a
        // named field rather than an anonymous boolean.
        map(response => ({ eligible: response?.data?.feedbackEligible ?? false })),
        catchError((error: Error) => {
          console.error(error);
          throw new Error(error.message);
        })
      );
  }
}
